/*
 * Keeps the discount % badge (.sale_percent[data-sale-percent], rendered by snippets/price-list.liquid) in sync with
 * the selected variant. Loaded globally from layout/theme.liquid (not inline in the snippet) so it also covers
 * quick-buy modals, whose markup is inserted through DOMParser and therefore never executes inline scripts.
 */
document.addEventListener("variant:change", function (event) {
  // form.id is shadowed by the <input name="id"> inside the product form, so read the attribute.
  var formId = event.target && event.target.getAttribute && event.target.getAttribute("id");
  var variant = event.detail && event.detail.variant;
  if (!formId || !variant) return;

  document.querySelectorAll("[data-sale-percent]").forEach(function (el) {
    if (el.getAttribute("data-form") !== formId) return;
    var onSale = variant.compare_at_price > variant.price;
    el.hidden = !onSale;
    el.textContent = onSale
      ? Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + "%"
      : "";
  });
});
